import styled from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 600px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding-bottom: 8px;
  padding-top: 8px;
`;

export const Content = styled.div`
  border-top: 1px solid ${Palette.PrimaryGray._200};
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
  background: #fff;
  width: 100%;
  padding: 24px;
`;

export const Title = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
  margin-bottom: 10px;
`;
